var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": "",
      "default-active": _vm.$route.path
    }
  }, [_c('div', {
    class: {
      'logo-name': _vm.sidebar.opened, 'logo-img': !_vm.sidebar.opened
    }
  }, [(_vm.sidebar.opened) ? _c('span', [(_vm.baseInfo) ? _c('span', [_vm._v("青柠微影" + _vm._s(_vm.getUserTitle) + "管理后台")]) : _vm._e(), _vm._v(" "), (!_vm.baseInfo) ? _c('span', [_vm._v("青柠后台")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.sidebar.opened) ? _c('span', [_c('img', {
    staticClass: "logoImage",
    attrs: {
      "src": require("../../../static/image/logo.png"),
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sidebar-item', {
    attrs: {
      "routes": _vm.routes
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fae5d84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fae5d84","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = Ch8x
// module chunks = 212